import { request } from '../../utils/request';

export const removeDiscountFromProduct = (
  discountId: number,
  authToken: string
) =>
  request({
    method: 'DELETE',
    url: `/products/discount/${discountId}`,
    callback: undefined,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    onError: (err) => {
      throw err;
    },
  });
